/** Stader ETHx UserWithdrawalManager — per-user enumeration +
 *  per-request detail. Address on chain 1:
 *  `0x9f0491b32dbce587c50c4c43ab303b06478193a7`. */
export const StaderEthxWithdrawalAbi = [
  {
    name: 'getRequestIdsByUser',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: '_owner' }],
    outputs: [{ type: 'uint256[]' }],
  },
  {
    name: 'userWithdrawRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'requestId' }],
    outputs: [
      { type: 'address', name: 'owner' },
      { type: 'uint256', name: 'ethXAmount' },
      { type: 'uint256', name: 'ethExpected' },
      { type: 'uint256', name: 'ethFinalized' },
      { type: 'uint256', name: 'requestBlock' },
    ],
  },
  {
    name: 'nextRequestIdToFinalize',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
